module.exports = __webpack_public_path__ + "96df34a9e0086ef7a43723d1860ecaea.jpg";